import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as g, createElementVNode as r, createCommentVNode as m } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, h = { key: 1 }, k = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, w = { key: 5 }, _ = {
  name: "ScalarIconWifiNone"
}, v = /* @__PURE__ */ p({
  ..._,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const d = s, { bind: i, weight: n } = A(d);
    return (a, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(i)), [
      g(a.$slots, "default"),
      l(n) === "bold" ? (o(), e("g", f, t[0] || (t[0] = [
        r("path", { d: "M144,204a16,16,0,1,1-16-16A16,16,0,0,1,144,204Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (o(), e("g", h, t[1] || (t[1] = [
        r("path", { d: "M247.89,80.91a15.93,15.93,0,0,0-6.17-10.81A186.67,186.67,0,0,0,128,32,186.67,186.67,0,0,0,14.28,70.1,15.93,15.93,0,0,0,8.11,80.91,15.65,15.65,0,0,0,11.65,92.8l104,125.43A15.93,15.93,0,0,0,128,224h0a15.93,15.93,0,0,0,12.31-5.77h0l104-125.43A15.65,15.65,0,0,0,247.89,80.91ZM128,208,24.09,82.74A170.76,170.76,0,0,1,128,48,170.76,170.76,0,0,1,231.91,82.74Z" }, null, -1)
      ]))) : l(n) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        r("path", { d: "M247.89,80.91a15.93,15.93,0,0,0-6.17-10.81A186.67,186.67,0,0,0,128,32,186.67,186.67,0,0,0,14.28,70.1,15.93,15.93,0,0,0,8.11,80.91,15.65,15.65,0,0,0,11.65,92.8l104,125.43A15.93,15.93,0,0,0,128,224h0a15.93,15.93,0,0,0,12.31-5.77h0l104-125.43A15.65,15.65,0,0,0,247.89,80.91ZM128,208,24.09,82.74A170.76,170.76,0,0,1,128,48,170.76,170.76,0,0,1,231.91,82.74Z" }, null, -1)
      ]))) : l(n) === "light" ? (o(), e("g", M, t[3] || (t[3] = [
        r("path", { d: "M138,204a10,10,0,1,1-10-10A10,10,0,0,1,138,204Z" }, null, -1)
      ]))) : l(n) === "regular" ? (o(), e("g", Z, t[4] || (t[4] = [
        r("path", { d: "M140,204a12,12,0,1,1-12-12A12,12,0,0,1,140,204Z" }, null, -1)
      ]))) : l(n) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        r("path", { d: "M136,204a8,8,0,1,1-8-8A8,8,0,0,1,136,204Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  v as default
};
